import script from "./jump-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./jump-block.vue?vue&type=script&lang=ts&setup=true"

import "./jump-block.vue?vue&type=style&index=0&id=2d191c26&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d191c26"]])

export default __exports__